import { ErrorCircleColored } from "components/icons/generated";
import SystemMessage from "components/SystemMessage";
import Link from "ds/components/Link";
import useTitle from "hooks/useTitle";

const UnauthorizedPage = () => {
  useTitle("Unauthorized");

  return (
    <SystemMessage
      icon={ErrorCircleColored}
      title="Unauthorized"
      message={
        <>
          Sorry, looks like you're not authorized to access this Spacelift account. This could well
          be an error - try <Link href="/login">logging in again</Link> to see if that helps.
        </>
      }
    />
  );
};

export default UnauthorizedPage;
